require('./AddGroupSignin.css');

const canvas = document.getElementById('signatureCanvas');
const signaturePad = new SignaturePad(canvas);

// Set canvas width dynamically
const container = document.querySelector('.signature-container');
const updateCanvasSize = () => {
    canvas.width = 600; // Match the width with the container
    canvas.height = 200; // Set a fixed height (you can change this if needed)
};

// Update canvas size on page load and window resize
updateCanvasSize();
window.addEventListener('resize', updateCanvasSize);

// Clear signature functionality
document.getElementById("clearSignature").addEventListener("click", function() {
    signaturePad.clear();
});

// Popovers and tooltips
document.addEventListener("DOMContentLoaded", function () {
    // Initialize all tooltips
    document.querySelectorAll('[data-toggle="tooltip"]').forEach(function (tooltipElement) {
        new bootstrap.Tooltip(tooltipElement);
    });

    // Initialize all popovers
    document.querySelectorAll('[data-toggle="popover"]').forEach(function (popoverElement) {
        new bootstrap.Popover(popoverElement);
    });
});

// Datepicker for date of birth and entry date
document.addEventListener("DOMContentLoaded", function () {
    const dateOfBirthPicker = flatpickr("#dateofbirth", {
        dateFormat: "d.m.Y",  // Equivalent to dd.mm.yyyy
        defaultDate: "01.01.2000",  // Default date (year 2000)
        locale: "de",  // German language
        allowInput: true,
        altInput: true,
        altFormat: "d.m.Y",
        disableMobile: true  // Use Flatpickr even on mobile devices
    });

    const entryDatePicker = flatpickr("#entryDate", {
        dateFormat: "d.m.Y",
        defaultDate: new Date(),
        locale: "de",
        allowInput: true,
        altInput: true,
        altFormat: "d.m.Y",
        disableMobile: true
    });

    document.querySelector("#dateOfBirthPickerButton").addEventListener("click", function () {
        dateOfBirthPicker.open();
    });

    document.querySelector("#entryDatePickerButton").addEventListener("click", function () {
        entryDatePicker.open();
    });
});

// Nationality radio buttons and text field
document.addEventListener("DOMContentLoaded", function () {
    const nationalityRadios = document.querySelectorAll("input[type=radio][name=nationality]");
    const nationalityOthersText = document.getElementById("nationalityOthersText");

    nationalityRadios.forEach(radio => {
        radio.addEventListener("change", function () {
            if (this.value === "german") {
                nationalityOthersText.value = "";
            }
        });
    });

    nationalityOthersText.addEventListener("click", function () {
        document.querySelector("input[type=radio][name=nationality][value='others']").checked = true;
    });
});

// Form validations
document.addEventListener("DOMContentLoaded", function () {
    const validator = new JustValidate("#groupSigninForm", {
        errorFieldCssClass: "is-invalid",
        successFieldCssClass: "is-valid",
        errorLabelCssClass: "invalid-feedback",
    });

    validator
        .addField("#prename", [
            { rule: "required", errorMessage: "Bitte gib einen Vornamen ein." },
            { rule: "minLength", value: 2, errorMessage: "Es werden mindestens 2 Buchstaben benötigt!" },
            { validator: value => !value.includes('/'), errorMessage: "Der Vorname darf das Zeichen / nicht enthalten." }
        ])
        .addField("#surname", [
            { rule: "required", errorMessage: "Bitte gib einen Nachnamen ein." },
            { rule: "minLength", value: 2, errorMessage: "Es werden mindestens 2 Buchstaben benötigt!" },
            { validator: value => !value.includes('/'), errorMessage: "Der Nachname darf das Zeichen / nicht enthalten." }
        ])
        .addField("#nationalityOthersText", [
            {
                validator: (value, fields) => {
                    const nationality = document.querySelector("input[type=radio][name=nationality]:checked").value;
                    return nationality !== "others" || (nationality === "others" && value.trim() !== "");
                },
                errorMessage: "Bitte gib eine Staatsangehörigkeit ein, wenn 'Andere' ausgewählt ist."
            }
        ])
        .addField("#dateofbirth", [
            { rule: "required", errorMessage: "Bitte gib ein Geburtsdatum ein." },
            { 
                validator: value => window.customValidations.germanDate(value), 
                errorMessage: "Bitte gib ein gültiges Datum im Format tt.mm.yyyy ein." 
            }
        ])
        .addField("#entryDate", [
            { rule: "required", errorMessage: "Bitte gib ein Eintrittsdatum ein." },
            { 
                validator: value => window.customValidations.germanDate(value), 
                errorMessage: "Bitte gib ein gültiges Datum im Format tt.mm.yyyy ein." 
            }
        ])
        .addField("#street", [
            { rule: "required", errorMessage: "Bitte gib deine Straße und Hausnummer ein." },
            { validator: value => window.customValidations.street(value), errorMessage: "Bitte gib eine gültige Straße ein." }
        ])
        .addField("#postcode", [
            { rule: "required", errorMessage: "Bitte gib eine Postleitzahl ein." },
            { validator: value => window.customValidations.postcode(value), errorMessage: "Bitte gib eine gültige Postleitzahl ein." }
        ])
        .addField("#city", [
            { rule: "required", errorMessage: "Bitte gib eine Stadt ein." },
            { validator: value => window.customValidations.city(value), errorMessage: "Bitte gib eine gültige Stadt ein." }
        ])
        .addField("#cellphone", [
            { rule: "required", errorMessage: "Bitte gib deine Mobilfunknummer ein." },
            { validator: value => window.customValidations.phoneNumber(value), errorMessage: "Bitte gib eine gültige Telefonnummer ein." }
        ])
        .addField("#email", [
            { rule: "required", errorMessage: "Bitte gib eine E-Mail Adresse ein." },
            { rule: "email", errorMessage: "Bitte gib eine gültige E-Mail Adresse ein." }
        ])
        .addField("#directDebitPrename", [
            { rule: "required", errorMessage: "Bitte gib einen Vornamen ein." },
            { rule: "minLength", value: 2, errorMessage: "Es werden mindestens 2 Buchstaben benötigt!" },
            { validator: value => !value.includes('/'), errorMessage: "Der Vorname darf das Zeichen / nicht enthalten." }
        ])
        .addField("#directDebitSurname", [
            { rule: "required", errorMessage: "Bitte gib einen Nachnamen ein." },
            { rule: "minLength", value: 2, errorMessage: "Es werden mindestens 2 Buchstaben benötigt!" },
            { validator: value => !value.includes('/'), errorMessage: "Der Nachname darf das Zeichen / nicht enthalten." }
        ])
        .addField("#directDebitStreet", [
            { rule: "required", errorMessage: "Bitte gib deine Straße und Hausnummer ein." },
            { validator: value => window.customValidations.street(value), errorMessage: "Bitte gib eine gültige Straße ein." }
        ])
        .addField("#directDebitPostcode", [
            { rule: "required", errorMessage: "Bitte gib eine Postleitzahl ein." },
            { validator: value => window.customValidations.postcode(value), errorMessage: "Bitte gib eine gültige Postleitzahl ein." }
        ])
        .addField("#directDebitCity", [
            { rule: "required", errorMessage: "Bitte gib eine Stadt ein." },
            { validator: value => window.customValidations.city(value), errorMessage: "Bitte gib eine gültige Stadt ein." }
        ])
        .addField("#directDebitIban", [
            { rule: "required", errorMessage: "Bitte gib eine IBAN ein." },
            { validator: value => window.customValidations.IBAN(value), errorMessage: "Bitte gib eine gültige IBAN ein." }
        ])
        .addField("#directDebitInstitute", [
            { rule: "required", errorMessage: "Bitte gib ein Kreditinstitut ein." },
            { rule: "minLength", value: 2, errorMessage: "Es werden mindestens 2 Buchstaben benötigt!" },
            { validator: value => !value.includes('/'), errorMessage: "Das Kreditinstitut darf das Zeichen / nicht enthalten." }
        ])
        .addField("#directDebitBic", [
            { rule: "required", errorMessage: "Bitte gib eine BIC ein." },
            { validator: value => window.customValidations.BIC(value), errorMessage: "Bitte gib eine gültige BIC ein." }
        ])
        .addField("#membershipConfirmation", [
            { rule: "required", errorMessage: "Bitte akzeptiere die Bestätigung zu den Mitgliedschaftsinformationen." }
        ])
        .addField("#membershipApplication", [
            { rule: "required", errorMessage: "Bitte akzeptiere die Bestätigung zu den Mitgliedschaft." }
        ])
        .onSuccess(async () => { 
            if (signaturePad.isEmpty()) {
                Swal.fire({
                    title: "Unterschrift erforderlich",
                    text: "Bitte unterschreibe das Formular.",
                    icon: "warning",
                    confirmButtonText: "OK"
                });
                return false;
            }

            // Get the signature image as a blob
            const signatureImage = signaturePad.toDataURL();
            const blob = dataURLtoBlob(signatureImage); // Convert data URL to Blob
 
            // Prepare the form data to send the signature to the server
            const formData = new FormData();
            formData.append("signature", blob, "signature.png");

            try {
                const response = await uploadSignatureImage(formData);
                console.log(response);
                if (response.success) {
                    const filename = response.data[0].data.filename;
                    // Set a value for the hidden input after the signature is captured
                    document.querySelector('input[name="signatureFileName"]').value = filename;

                    console.log("Formular ist gültig!");
                    document.querySelector("#groupSigninForm").submit(); 
                } else {
                    Swal.fire({
                        title: "Unterschrift übertragen fehlgeschlagen",
                        text: "Die Unterschrift konnte nicht übertragen werden. Bitte versuche es erneut.",
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                    return false;
                }
            } catch (error) {
                Swal.fire({
                    title: "Unterschrift übertragen fehlgeschlagen",
                    text: "Die Unterschrift konnte nicht übertragen werden. Bitte versuche es erneut.",
                    icon: "error",
                    confirmButtonText: "OK"
                });
                return false;
            } 
        });
});

// Helper function to convert DataURL to Blob
function dataURLtoBlob(dataURL) {
    const [metadata, base64Data] = dataURL.split(',');
    const mime = metadata.match(/:(.*?);/)[1];
    const binary = atob(base64Data);
    const length = binary.length;
    const arrayBuffer = new ArrayBuffer(length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < length; i++) {
        uint8Array[i] = binary.charCodeAt(i);
    }

    return new Blob([arrayBuffer], { type: mime });
}

// Upload function using Fetch API with progress tracking
async function uploadSignatureImage(formData) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", targetUrl, true);

        xhr.onload = function () {
            if (xhr.status === 200) {
                resolve({ success: true, data: JSON.parse(xhr.responseText) });
            } else {
                reject(new Error("Upload failed"));
            }
        };

        xhr.onerror = function () {
            reject(new Error("Network error"));
        };

        xhr.send(formData);
    });
}